var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"fluid-container footer ml-auto mr-auto"},[_c('p',{staticClass:"text-center"},[_vm._v("Copyright "),_c('span',{attrs:{"size":"large"}},[_vm._v("©")]),_vm._v(" 2021 GPS Technologies. All Rights Reserved.")])])])
}]

export { render, staticRenderFns }